import SessionStorage from "../storage/SessionStorage.js";

const sessionKeys = {
  PARTY: "party",
  LANGUAGE: "party-language"
};

const PartySession = (function () {
  const getParty = function () {
    return SessionStorage.retreive(sessionKeys.PARTY);
  };

  const setParty = function (party) {
    SessionStorage.persist(sessionKeys.PARTY, party);
  };

  const deleteParty = function () {
    SessionStorage.remove(sessionKeys.PARTY);
  };

  const existsParty = function () {
    return SessionStorage.exists(sessionKeys.PARTY);
  };

  const getPartyId = function () {
    return getParty()?.id;
  };

  const isPartyLoggedIn = function () {
    const partyExists = existsParty();
    const isPartyLoggedIn = partyExists;
    return isPartyLoggedIn;
  };

  const deletePartySession = function () {
    deleteParty();
    deleteLanguage();
  };

  const getLanguage = function () {
    return SessionStorage.retreive(sessionKeys.LANGUAGE);
  };

  const setLanguage = function (language) {
    language
      ? SessionStorage.persist(sessionKeys.LANGUAGE, language)
      : deleteLanguage();
  };

  const deleteLanguage = function () {
    SessionStorage.remove(sessionKeys.LANGUAGE);
  };

  const languageExists = function () {
    return SessionStorage.exists(sessionKeys.LANGUAGE);
  };

  return {
    getPartyId: getPartyId,
    getParty: getParty,
    setParty: setParty,
    deleteParty: deleteParty,
    isPartyLoggedIn: isPartyLoggedIn,
    deletePartySession: deletePartySession,
    getLanguage: getLanguage,
    setLanguage: setLanguage,
    deleteLanguage: deleteLanguage,
    languageExists: languageExists
  };
})();

export default PartySession;
